module.exports = __webpack_public_path__ + "img/15_21.ad442dc8.png";